import { LocalizationProvider } from "@mui/x-date-pickers";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Routes, Route } from "react-router-dom";

import LoginPage from "./pages/login/LoginPage";
import MainLayout from "./components/layout/MainLayout";
import MainPage from "./pages/main/mainPage";

import { ContasAPagarLancamento } from "./pages/contas/ContasAPagarLancamento";
import { ContasAPagarConsulta } from "./pages/contas/ContasAPagarConsulta";
import { ContasAPagarFornecedor } from "./pages/contas/ContasAPagarFornecedor";
import { AgenteCobrador } from "./pages/contas/cadastros/AgenteCobrador";
import { CentroCusto } from "./pages/contas/cadastros/CentroCusto";
import { Despesa } from "./pages/contas/cadastros/Despesa";
import { TipoDocumento } from "./pages/contas/cadastros/TipoDocumento";
import { TipoFornec } from "./pages/contas/cadastros/TipoFornec";
import { PlanoContas } from "./pages/contas/cadastros/PlanoContas";
import { Estabelecimento } from "./pages/contas/cadastros/Estabelecimento";
import { ContaCorrente } from "./pages/contas/cadastros/ContaCorrente";
import { TipoPag } from "./pages/contas/cadastros/TipoPag";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<MainLayout />}>
          <Route path="/main" element={<MainPage />} />
          <Route
            path="/contas-a-pagar/fornecedor"
            element={<ContasAPagarFornecedor />}
          />
          <Route
            path="/contas-a-pagar/lancamento"
            element={<ContasAPagarLancamento />}
          />
          <Route
            path="/contas-a-pagar/consulta"
            element={<ContasAPagarConsulta />}
          />
          <Route
            path="/contas-a-pagar/agente-cobrador"
            element={<AgenteCobrador />}
          />
          <Route
            path="/contas-a-pagar/centro-de-custo"
            element={<CentroCusto />}
          />
          <Route path="/contas-a-pagar/despesa" element={<Despesa />} />
          <Route
            path="/contas-a-pagar/tipo-de-documento"
            element={<TipoDocumento />}
          />
          <Route
            path="/contas-a-pagar/tipo-de-fornecedor"
            element={<TipoFornec />}
          />
          <Route
            path="/contas-a-pagar/plano-contas"
            element={<PlanoContas />}
          />
          <Route
            path="/contas-a-pagar/estabelecimento"
            element={<Estabelecimento />}
          />
          <Route
            path="/contas-a-pagar/conta-corrente"
            element={<ContaCorrente />}
          />
          <Route path="/contas-a-pagar/tipo-pagamento" element={<TipoPag />} />
        </Route>
      </Routes>
    </LocalizationProvider>
  );
}

export default App;
